<script setup lang="ts">
import { NEmpty } from 'naive-ui'
import { useAttrs } from 'vue'

const props = withDefaults(defineProps<{
  size?: 'small' | 'medium' | 'large' | 'huge'
  description?: string
}>(), {
  size: 'medium',
  description: undefined,
})

const attrs = useAttrs()
</script>

<template>
  <NEmpty
    :size="size"
    :description="description"
    v-bind="attrs"
  >
    <template #icon>
      <slot name="icon" />
    </template>
    <template #extra>
      <slot name="extra" />
    </template>
  </NEmpty>
</template>

<style scoped>
/* Custom styles can be added here if needed */
</style>
